@if ((changelog$ | async); as changelog) {
  @if (changelog.length > 0) {
    <div
      class="alert alert-info"
      role="note">
      <h2 class="ba-heading" id="Changelog_Box_Title">Hinweis</h2>
      <p>Es wurden folgende Felder neu hinzugefügt. Bitte prüfen Sie, ob weitere Eingaben erforderlich sind:</p>
      <div class="row ba-form-row">
        @for (change of changelog; track change; let i = $index) {
          <div
            class="col-12"
            [attr.data-index]="i">
            <a (click)="jumpTo($event, change.inputId)" href="#">{{getLabelFor(change)}}</a>
          </div>
        }
      </div>
    </div>
  }
}
